<template>
    <!-- 订单管理/零售订单管理 -->
    <div>
        <content-view>
            <div slot="header">
                <a-form :form="formHeader" layout="inline" class="store-one-form">
                <a-form-item label="交易订单号">
                    <a-input placeholder="请输入" v-decorator="['tradeNo']" @pressEnter="search(false)"></a-input>
                </a-form-item>
                <a-form-item label="会员手机号">
                    <a-input placeholder="请输入" v-decorator="['phone']" @pressEnter="search(false)"></a-input>
                </a-form-item>
                <a-form-item label="购买门店">
                    <a-select allowClear placeholder="请选择" v-decorator="['shopId']" @select="search(false)">
                        <a-select-option v-for="item in shopList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="支付金额">
                    <a-input-group compact >
                        <a-input class="range-input range-input-left" placeholder="最小金额" v-decorator="['minPayAmount']" />
                        <a-input style="width: 40px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="~" disabled />
                        <a-input class="range-input range-input-right" placeholder="最大金额" v-decorator="['maxPayAmount']" />
                    </a-input-group>
                </a-form-item>
                <a-form-item label="支付时间">
                    <a-range-picker style="width:282px" v-decorator="['selectDate']" format="YYYY/MM/DD" @cahnge="search(false)"/>
                </a-form-item>
                <a-form-item label="支付方式">
                    <a-select allowClear placeholder="请选择" v-decorator="['payMode']" @select="search(false)">
                        <template v-for="(item,index) in $utils.payMode">
                            <a-select-option :key="index" :value="index" v-if="item && index > 0">{{item}}</a-select-option>
                        </template>
                    </a-select>
                </a-form-item>
                <a-form-item label="订单状态">
                    <a-select allowClear placeholder="请选择" v-decorator="['tradeState']" @select="search(false)">
                        <a-select-option value="1" >待支付</a-select-option>
                        <a-select-option value="2" >已支付</a-select-option>
                        <a-select-option value="3" >支付失败</a-select-option>
                        <a-select-option value="4" >退款中</a-select-option>
                        <a-select-option value="6" >全部退款</a-select-option>
                        <a-select-option value="7" >已关闭</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="收银台">
                    <a-select :options="ticketPlatformOptions" placeholder="请选择" v-decorator="['counterId']" @select="search(false)"></a-select>
                </a-form-item>
                <a-form-item label="收银员">
                    <a-input placeholder="请输入" v-decorator="['cashier']" @pressEnter="search(false)"></a-input>
                </a-form-item>
                <a-form-item label="人工确认">
                    <a-select allowClear placeholder="请选择" v-decorator="['isManualPayment']" @select="search(false)">
                        <a-select-option value="true">是</a-select-option>
                        <a-select-option value="false">否</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button @click="search(false)" :loading="searchLoading" class="mr8" type="primary">筛选</a-button>
                    <a-button @click="handleReset">重置</a-button>
                </a-form-item>
                </a-form>
            </div>
            <a-card :bordered="false">
                <template slot="extra" v-if="getBtnByAuth('exportRetail')">
                    <a-button type="primary" @click="search(true)" :loading="loading">导出excel</a-button>
                    <a-button @click="openExportModal">导出记录</a-button>
                </template>
                <a-table :scroll="{y: 560}" bordered :loading="searchLoading" :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="(record, index) => index">
                    <span slot="myToFixed2" slot-scope="key">{{key | myToFixed2}}</span>
                    <span slot="discountAmount" slot-scope="a, row">{{row.discountAmount | myToFixed2}}</span>
                    <span slot="discountName" slot-scope="a, row">{{row.discountName ? row.discountName : "-"}}</span>
                    <span slot="payTime" slot-scope="payTime">{{payTime || "-"}}</span>
                    <span slot="orderAmount" slot-scope="orderAmount">{{$utils.toFixed(orderAmount, 2) || '0.00'}}</span>
                    <span slot="payAmount" slot-scope="payAmount">{{$utils.toFixed(payAmount, 2) || '0.00'}}</span>
                    <span slot="cashier" slot-scope="cashier">{{cashier || "-"}}</span>
                    <span slot="phone" slot-scope="phone">{{phone || "-"}}</span>
                    <span slot="isManualPayment" slot-scope="a, row">{{row.isManualPayment ? '是' : "否"}}</span>
                    <span slot="action" slot-scope="a, row">
                        <span v-if="getBtnByAuth('retailOrderLook')">
                            <a class="text-primary" @click="showModal(row, false)">账单查看</a>
                            <a-divider type="vertical"/>
                        </span>
                        <span v-if="getBtnByAuth('retailRefund')">
                            <a v-if="row.tradeState == '已支付'" class="text-primary" @click="showModal(row, true)">退款</a>
                            <span v-else class="text-disabled">退款</span>
                        </span>
                    </span>
                </a-table>
            </a-card>
            <a-modal class="billInfo" :title="modalTextSelect.title" v-model="visible" :okText="modalTextSelect.okText" :cancelText="modalTextSelect.cancelText" @ok="openRefundConfirm" @cancel="visible = false" :destroyOnClose="true" :width="1000">
                <a-row class="mb16">
                    <a-col :span="8">订单状态：{{detailData.transStateStr}}</a-col>
                    <a-col :span="8">交易订单号：{{detailData.transNo}}</a-col>
                    <a-col :span="8">是否人工确认：{{detailData.isManualPayment ? '是' : "否"}}</a-col>
                </a-row>
                <a-row class="mb16">
                    <a-col :span="8">购买者手机号：{{detailData.phone}}</a-col>
                    <a-col :span="8">购买者名称：{{detailData.account || '-'}}</a-col>
                    <a-col :span="8">下单时间：{{detailData.orderTime}}</a-col>
                </a-row>
                <a-table
                style="word-break:break-all;"
                bordered
                :dataSource="detailData.orderGoods"
                :columns="columns1"
                :pagination="false"
                :scroll="{y:300}"
                :rowKey="(record, index) => index"
                >
                    <span slot="refundNumber" slot-scope="text,record,index">
                        <a-input-number :disabled="refundAllState || !isRefund || modalTextSelect.disabledRefund" v-model="detailData.orderGoods[index].refundNumber" :min="0" :max="record.refundMax" style="width:60px;"></a-input-number>
                    </span>
                    <span slot="refundCount" slot-scope="text,record">{{record.refundCount === null ? 0 : record.refundCount}}</span>
                    <span slot="num" slot-scope="text,record">{{record.count}}</span>
                    <span slot="toFixed" slot-scope="amount">{{$utils.toFixed(amount, 2)}}</span>
                </a-table>
                <div class="mt16 border-gray">
                    <a-row class="mb16">
                        <a-col class="red" :span="12">收银台优惠使用：{{detailData.discountName || '--'}}</a-col>
                        <a-col class="red" :span="12">收银台优惠抵扣金额：{{detailData.discountAmount ? $utils.toFixed(detailData.discountAmount, 2) : '0.00'}} 元</a-col>
                    </a-row>
                    <a-row class="mb16">
                        <a-col class="red" :span="12">优惠券使用：{{detailData.couponName || '--'}}</a-col>
                        <a-col class="red" :span="12">优惠券抵扣金额：{{detailData.couponAmount ? $utils.toFixed(detailData.couponAmount, 2) : '0.00'}} 元</a-col>
                    </a-row>
                    <a-row class="mb16">
                        <a-col class="red" :span="12">实收金额/元：{{$utils.toFixed(detailData.payAmount, 2)}} 元</a-col>
                        <a-col class="red" :span="12">已退金额/元：{{detailData.refundAmount === null ? '0.00' : $utils.toFixed(detailData.refundAmount, 2)}} 元</a-col>
                    </a-row>
                    <a-row class="mb16">
						<a-col :span="12">购买途径：{{!detailData.platform ? "--" : detailData.platform == "收银台" ? detailData.shopName : detailData.platform}}</a-col>
                        <a-col :span="12">支付方式：{{$utils.payMode[detailData.payMode] || '--'}}</a-col>
                    </a-row>
                    <a-row class="mb16" v-if="!isRefund">
                        <a-col :span="12">备注类型：{{detailData.remarkCategoryName || '--'}}</a-col>
                        <a-col :span="12">备注：{{detailData.remark || '--'}}</a-col>
                    </a-row>
                    <a-row class="mb16">
						<a-col :span="12">退款状态：{{['--','退款中',successMsg,'退款失败'][detailData.refundState]}}</a-col>
                        <a-col :span="12">退款状态说明：{{detailData.thirdPartyMsg || '--'}}</a-col>
                    </a-row>
                </div>
                <div class="mt16 border-gray" v-if="isRefund">
                    <a-form :form="form">
                        <a-form-item label="实退金额" required :labelCol="{span: 3}" :wrapperCol="{span: 16}">
                            <a-input-number :disabled="true" style="width:40%" :min="0" :max="refundAmountMax" v-model="detailData.amount" placeholder="请输入"></a-input-number>
                            <span class="red ml24">参考应退金额：{{refundNum2}} 元</span>
                        </a-form-item>
                        <remark :disabled="modalTextSelect.disabledRefund" :labelSpan="3" :wrapperSpan="16" operateCode="RetailRefund" />
                        <a-divider></a-divider>
                        <a-form-item v-if="isRefund" label="是否返还库存：" required :labelCol="{span: 3}" :wrapperCol="{span: 6}">
                            <a-radio-group :disabled="modalTextSelect.disabledRefund" v-model="isRefundInventory">
                                <a-radio :value="1">返还</a-radio>
                                <a-radio :value="0">不返还</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-form>
                </div>
                <div class="mt16 border-gray pb16" v-if="isRefund">
                    <a-form :form="form" layout="inline">
                        <a-form-item label="审核人账号" required >
                            <a-input :disabled="modalTextSelect.disabledRefund" v-model="auditAccount" placeholder="请输入" style="width:100%"/>
                        </a-form-item>
                        <a-form-item label="审核人密码" required >
                            <a-input :disabled="modalTextSelect.disabledRefund" type="password" autocomplete="new-password" v-model="auditPassword" placeholder="请输入" style="width:100%" />
                        </a-form-item>
                        <a-form-item label="是否发送短信通知" required>
                            <a-radio-group :disabled="modalTextSelect.disabledRefund" v-model="isSendMessage" style="width:100%">
                                <a-radio :value="1">是</a-radio>
                                <a-radio :value="0">否</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-form>
                </div>
                <div class="mt16 border-gray" v-if="!isRefund && detailData.auditer">
                    <a-row class="mb16">
                        <a-col class="red" :span="12">退款审核人：{{detailData.auditer}}</a-col>
                        <a-col class="red" :span="12">退款审核时间：{{detailData.auditTime}}</a-col>
                    </a-row>
                </div>
                <div class="text-fail mt16" v-if="isRefund && (detailData.payMode == 3 || detailData.payMode == 4 || (detailData.payMode == 11 && detailData.isManualPayment))">*该笔订单系统无法自动退款。请先在系统内发起“退款”申请，再完成线下退款流程</div>
            </a-modal>
            <report-export-modal ref="reportExportModal" :exportType="5"></report-export-modal>
        </content-view>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
import remark from '@/components/modules/platform/remark.component';
import utils from '../../utils';
    const columns = [
    {
        title: "交易订单号",
        dataIndex: "tradeNo"
    },
    {
        title: "会员手机号",
        dataIndex: "phone",
        scopedSlots: { customRender: "phone" }
    },
    {
        title: "支付时间",
        dataIndex: "payTime",
        scopedSlots: { customRender: "payTime" }
    },
    {
        title: "购买门店",
        dataIndex: "shopName"
    },
    {
        title: "订单金额",
        dataIndex: "orderAmount",
        scopedSlots: { customRender: "orderAmount" }
    },
    {
        title: "支付金额",
        dataIndex: "payAmount",
        scopedSlots: { customRender: "payAmount" }
    },
    {
        title: "订单状态",
        dataIndex: "tradeState",
    },
    {
        title: "是否人工确认",
        dataIndex: "isManualPayment",
        scopedSlots: { customRender: "isManualPayment" }
    },
    {
        title: "收银台",
        dataIndex: "counterName"
    },
    {
        title: "收银员",
        dataIndex: "cashier",
        scopedSlots: { customRender: "cashier" }
    },
    {
        title: "优惠金额",
        dataIndex: "discountAmount",
        scopedSlots: { customRender: "discountAmount" }
    },
    {
        title: "优惠名称",
        dataIndex: "discountName",
        scopedSlots: { customRender: "discountName" }
    },
    {
        title: "操作",
        key: "action",
        scopedSlots: { customRender: "action" }
    }
    ];
    const columns1 = [
    {
        title: "退款数量",
        width: 100,
        scopedSlots: { customRender: "refundNumber" }
    },
    {
        title: "已退数量",
        dataIndex: "refundCount",
        width: 50,
        scopedSlots: { customRender: "refundCount" }
    },
    {
        title: "商品名称",
        dataIndex: "goodsName",
        width: 120,
    },
    {
        title: "商品单价",
        dataIndex: "price",
        width: 60,
        scopedSlots: {customRender: 'toFixed'}
    },
    {
        title: "购买数量",
        dataIndex: "count",
        width: 60,
        scopedSlots: { customRender: "count" }
    },
    {
        title: "合计",
        dataIndex: "beforeDiscountPrice",
        width: 60,
        scopedSlots: {customRender: 'toFixed'}
    },
    {
        title: "折后合计",
        dataIndex: "totalPrice",
        width: 60,
        scopedSlots: { customRender: "toFixed" }
    }];
    export default {
        name: "retailOrder",
        components: {
            remark
        },
        props: {},
        data() {
            const modalText = [
                {
                    title: "账单",
                    okText: "确定",
                    cancelText: "取消",
                    disabledRefund: false,
                },
                {
                    title: "退款",
                    okText: "发起退款订单",
                    cancelText: "取消",
                    disabledRefund: false,
                },
                {
                    title: "账单",
                    okText: "确定",
                    cancelText: "账单",
                    disabledRefund: true,
                },
            ]
            return {
                modalText,
                // 零售订单表头
                columns,
                dataSource: [],
                shopList: [],
                // 零售账单/退款表头
                columns1,
                isRefund: false,
                visible: false,
                detailData: {
                    orderGoods: []
                },
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                loading: false,
                refundAllState: false,
                isRefundInventory: 1,
                searchLoading: false,
                modalTextSelect: {
                    disabledRefund: false,
                    title: '',
                    okText: '',
                    cancelText: '',
                },
                auditAccount: undefined,
                auditPassword: undefined,
                isSendMessage: undefined,
                refundAmountMax: 0,
                successMsg: '',
                ticketPlatformOptions: []
            };
        },

        computed: {
            ...mapGetters(["shopId"]),
            // 参考应退金额
            refundNum2 () {
                let val = 0; // 参考应退金额
                let refundCount = 0; // 已退总数量
                let refundNumber = 0; // 将退总数量
                let buyCount = 0; // 已买总数量
                this.detailData.orderGoods && this.detailData.orderGoods.forEach((item,index) => {
                    val += item.refundNumber * item.price;
                    refundCount += item.refundCount;
                    refundNumber += item.refundNumber;
                    buyCount += item.count;
                });
                if(this.refundAllState || (refundNumber > 0 && (refundCount + refundNumber == buyCount))) {
                    val = this.detailData.payAmount - this.detailData.refundAmount;
                }
                return utils.toFixed(val, 2)
            },
        },
        methods: {
            /**
             * @cashPayPlatform 获取门店下票台列表
             */
            cashPayPlatform() {
                this.$api.ticketDesk.cashPayPlatform({
                    body: {
                        pageNum: 1,
                        pageSize: 999999,
                    }
                }).then(res => {
                    if (res && res.list) {
                        res.list.forEach(item => {
                            item.label = item.name;
                            item.value = item.id;
                        });
                        this.ticketPlatformOptions = res.list;
                    }
                })
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                this.getList()
            },
            handleReset() {
                this.formHeader.resetFields();
                this.pagination.current = 1;
                this.pagination.pageSize = 20;
                this.getList();
            },
            search(isExport) {
                this.pagination.current = 1;
                this.getList(isExport);
            },
            getShopList() {
                this.$api.totalPlatform.selectList().then(res => {
                    let shopIdList = this.$userInfoTool.getUser().shopIdList;
                    this.shopList = res.filter(i => {
						return shopIdList.find($i => {
							return $i === i.id;
						})
					});
                    if (shopIdList.find(el => el == -1)) {
                        this.shopList = res;
                        return;
                    }
                });
            },
            // 获取零售订单列表
            getList(isExport) {
                if (this.searchLoading) {
                    return false;
                }
                this.formHeader.validateFields((err, values) => {
                    if (err) return;
                    const orderTime = values['selectDate'] ? values['selectDate'] : []
                    values.minPayTime = orderTime.length > 0 ? orderTime[0].format('YYYY-MM-DD') : undefined
                    values.maxPayTime = orderTime.length > 0 ? orderTime[1].format('YYYY-MM-DD') : undefined

                    delete values['selectDate'];
                    this.searchLoading = true;
                    this.loading = true;
                    this.$api.order.orderSearch({
                        query: Object.assign(values,
                        {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                            goodsType: "RETAIL",
                            platform: 1,
                        })
                    })
                    .then(res => {
                        this.searchLoading = false;
                        this.pagination.total = res.total;
                        this.dataSource = res.list;
                        if(Boolean(isExport)) {
                            this.exportExcel();
                        } else {
                            this.loading = false;
                        }
                    }).catch(err => {
                        this.searchLoading = false;
                        this.loading = false;
                    });
                });
            },

            // 导出excel
            exportExcel() {
                this.formHeader.validateFields((err, values) => {
                    if (err) return;
                    const rangeValue = values['selectDate'] ? values['selectDate'] : []
                    values.minPayTime = rangeValue.length > 0 ? rangeValue[0].format('YYYY-MM-DD') : undefined
                    values.maxPayTime = rangeValue.length > 0 ? rangeValue[1].format('YYYY-MM-DD') : undefined

                    delete values['selectDate'];
                    this.loading = true
                    this.$api.order.orderExport({
                        query: Object.assign(values,
                        {
                            pageNum: 1,
                            pageSize: this.pagination.total,
                            goodsType: "RETAIL",
                            platform: 1,
                        })
                    },
                    {
                        responseType: "blob"
                    }
                    ).then(res => {
                        this.openExportModal();
                        this.loading = false;
                    }).catch(err => {
                        this.loading = false
                    })
                });
            },

            getDetail({tradeNo, tradeState}) {
                this.$api.order.viewTrade({
					body: {transNo: tradeNo, source: 'RETAIL', transStateStr: tradeState}
                }).then(res => {
                    this.refundAmountMax = Number(utils.toFixed(res.payAmount - res.refundAmount,2));
                    res.orderGoods.forEach(item => {
                        item.refundNumber = 0;
                        item.refundMax = item.count - item.refundCount;
                    })
                    res.amount = this.refundAmountMax;
                    this.detailData = res;
                    if((res.payMode == 11 && res.isManualPayment) || res.payMode == 3 || res.payMode == 4) {
                        this.successMsg = '退款成功（走线下）';
                    }else {
                        this.successMsg = '退款成功（系统已退）';
                    }
                    ////8月11号发布大版本改动
                    this.refundAllState = true;
                    this.refundAll({target: {checked: true}});
                });
            },
            showModal(item, isRefund) {
                this.visible = true;
                this.isRefund = isRefund;
                this.modalTextSelect = this.modalText[Number(this.isRefund)];
                this.refundAllState = false;
                this.auditAccount = undefined;
                this.auditPassword = undefined;
                this.isSendMessage = undefined;
                this.getDetail(item);
            },
            openRefundConfirm() {
                let refundDetailDTOS = this.detailData.orderGoods.filter((item,index) => {
                    item.count = item.refundNumber;
                    return item.refundNumber > 0;
                });
                if (this.isRefund) { // 退款
                    if(refundDetailDTOS.length === 0){
                        this.$message.error('请输入退款数量');
                        return false;
                    }
                    if(this.detailData.amount != 0 && !this.detailData.amount) {
                        this.$message.error('请输入退款金额');
                        return false
                    }
                    if(!this.auditAccount) {
                        this.$message.error('请输入审核人账号');
                        return false
                    }
                    if(!this.auditPassword) {
                        this.$message.error('请输入审核人密码');
                        return false
                    }
                    if(this.isSendMessage != 0 && this.isSendMessage != 1) {
                        this.$message.error('请选择是否发送短信');
                        return false
                    }
                    this.form.validateFields((err, values) => {
                        if (!err) {
                            setTimeout(() => {
                                this.modalTextSelect = this.modalText[2]
                            }, 300);
                        }
                    })
                } else { //详情
                    this.visible = false;
                }
                if (this.modalTextSelect.disabledRefund) { //审批
                    this.handleOk(refundDetailDTOS)
                }
            },
            // 退款二次审批确认
            handleOk(goods) {
                this.form.validateFields((err, values) => {
                    if (!err) {
                        this.$api.order
                        .refundOrderList({
                            body: {
                                orderNo: this.detailData.orderNo,
                                amount: this.detailData.amount,
								verify: 'uncheck',
								transNo: this.detailData.transNo,
								source: this.detailData.source,
								category: this.detailData.category,
								userId: this.detailData.userId,
                                reason: values.remark,
                                remarkCategoryCode: values.remarkCategoryCode,
                                remarkCategoryName: values.remarkCategoryName,
                                auditAccount: this.auditAccount,
                                auditPassword: this.auditPassword,
                                isSendMessage: this.isSendMessage,
                                goods
                            }
                        })
                        .then(res => {
                            this.$message.success('操作成功');
                            this.visible = false;
                            this.getList();
                        });
                    }
                })
            },
            refundAll(e) {
                this.refundAllState = e.target.checked;
                if(e.target.checked) {
                    this.detailData.orderGoods.forEach(item => {
                        item.refundNumber = item.refundMax;
                    });
                }
            },
            /**
             * @func openExportModal 打开导出记录弹窗
             */
            openExportModal() {
                this.$refs.reportExportModal.open();
            }
        },
        created() {},
        mounted() {
            this.cashPayPlatform();
            setTimeout(() => {
                this.getShopList()
                this.getList()
            }, 500);
        },
        watch: {
            'shopId'(val) {
                this.getList();
            }
        },
        beforeCreate() {
            this.formHeader = this.$form.createForm(this);
            this.form = this.$form.createForm(this);
        }
    };
</script>

<style lang="scss">
    .billInfo {
        .red {
            color: rgba(245, 34, 45, 1);
        }
        .border-gray{
            border:1px solid #ddd;
            padding: 16px 16px 0;
            .ant-input {
                width: 80% !important;
                margin-right: 16px;
            }
        }
    }
</style>
